import React from 'react'

function Footer() {
  return (
    <footer>Copyright ©Techhype 2023. All rights reserved.</footer>
  )
}

export default Footer;